<template>
<section class="buy-it-now px-4 bg-gray-500 pb-48 vt:pb-0">
    <div class="max-w-5xl mx-auto">
        <SmoothLoader tag="h2" class="text-primary-800 text-5xl vt:text-8xl uppercase font-headline leading-none" v-html="headline"></SmoothLoader>
        <div class="grid gap-2 py-8 vt:py-20">
            <SmoothLoader class="blurb mb-12" v-if="blurb">
                <div class="w-full vt:w-1/3 text-gray-900" v-html="blurb">
                </div>
            </SmoothLoader>
            <SmoothLoader v-for="(shop, i) in shops" :delay="i * 200">
                <a :href="shop.href" target="_blank" class="shop bg-secondary-600 rounded-md w-full flex items-center justify-center px-8 py-12 h-full hover:bg-primary-400 focus:bg-primary-400 relative">
                    <img :src="shop.logo.src" :alt="shop.name">
                    <span class="block message absolute w-full text-center left-0 text-white text-xl" v-if="shop.message" v-html="shop.message"></span>
                </a>
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>